import { useCallback } from 'react'
import { Room } from '@/core/models/room.model'
import { getConsultation, joinConsultationSocketEvent, leaveConsultationSocketEvent } from '@/redux/reducers/consultation.reducer'
import { enterEmergencyRoomSocketEvent, getRoom, leaveEmergencyRoomSocketEvent } from '@/redux/reducers/room.reducer'
import { useAppDispatch } from '@/redux/rootReducer'

export function useRefreshEmergencyRoom(emergencyRoom: Room) {
  const dispatch = useAppDispatch()
  return useCallback(() => {
    dispatch(getRoom(emergencyRoom._id))
    dispatch(leaveEmergencyRoomSocketEvent(emergencyRoom._id))
    dispatch(enterEmergencyRoomSocketEvent(emergencyRoom._id))

    const emergencyConsultationId = emergencyRoom.currentConsultation
    if (emergencyConsultationId) {
      dispatch(getConsultation(emergencyConsultationId))
      dispatch(leaveConsultationSocketEvent(emergencyConsultationId))
      dispatch(joinConsultationSocketEvent(emergencyConsultationId))
    }
  }, [dispatch, emergencyRoom])
}
